import "./Foot.css";
// import logo from './logo.png'


function Foot() {
  return (
    <div>
      <div className="containFoot">
      <div className="cp-right">Copyright © 2024 All Rights Reserved by InfosecIITG</div>
        <div className="rightitemsFoot">
          
          <div className="rightFoot">Coding Club</div>
        </div>
      </div>
    </div>
  );
}

export default Foot;
